import React from 'react';
import { useTranslation } from 'react-i18next';
import { translateText } from '../utils/translateText';

/** Inline text (use inside <Text>) that re-renders on language change. */
export default function T({ children }: { children?: React.ReactNode }) {
  useTranslation('ui');
  if (typeof children !== 'string') return <>{children}</>;
  return <>{translateText(children)}</>;
}
export const useTx = () => {
  useTranslation('ui');
  return translateText;
};
